import React, {useMemo, useEffect, useState} from 'react';
import '../../../css/scheduledCalls.css';
import Warning from '../../warning';
import { fetchWithDefaults } from '../../../config/fetchDefault';
import { fetchActivityThunk, incrementScheduleCall } from '../../../features/scheduledCallSlice';
import { useDispatch, useSelector } from 'react-redux';
import { formatTimestamp } from '../../../utilities/dashFunction';
 


function ScheduledCalls({ data, openLead, formatDate}) {

    const agentId = useSelector((state) => state.agent.userData).agentId;
    const dispatch = useDispatch();

    const [newData, setData] = useState(data);
     useEffect(()=>{
            setData(data)
        },[data])

    const [warning, setWarning] = useState(false);
    const scheduleCount = useMemo(() => {
        let count = 0;
        newData.forEach(data => {
            if(Array.isArray(data.tasks)){
                count += data.tasks.length
            }
        });
        return count;
    },[newData])
    const cancel = () => {
        setWarning(false);
    };
    const removeItem = (id,index) => {
        setWarning(id);
    };
    const confirm= async(callId)=>{
        try {
            const response = await fetchWithDefaults(`/cancelScheduledCall?callId=${callId}`);

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            if(response.ok){
                // dispatch activity api again to update data on delete call
                dispatch(fetchActivityThunk({agentIdNumber:agentId}))
                dispatch(incrementScheduleCall())
            }
            const jsonData = await response.json();
            if(jsonData.status===true){

                // Remove the canceled call from the data prop
                const updatedData = newData.map((item) => ({
                    ...item,
                    tasks: item.tasks.filter((call) => call.callId !== callId),
                }));

                setData(updatedData);
                setWarning(false);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const contactFormat = (inputDate) => {
        // Parse the input date string
        const dateObject = new Date(inputDate);

        // Format the date and time
        const formattedDate = `${(dateObject.getMonth() + 1).toString().padStart(2, '0')}/${
          dateObject.getDate().toString().padStart(2, '0')
        } @ ${
          dateObject.getHours() % 12 || 12
        }:${dateObject.getMinutes().toString().padStart(2, '0')}${
          dateObject.getHours() >= 12 ? 'pm' : 'am'
        }`;

        return formattedDate;
      };



    return (
        <div className="outerWrapper" style={{textAlign: 'center'}}>
            {warning &&
                <Warning title={"Delete Call"} cancel={cancel} confirm={() => confirm(warning)} message={"Are you sure you want to remove this call?"} buttons={[{name:'Don\'t Delete',action:'cancel'},{name:"Confirm Delete", action:'confirm'}]} />
            }
            <span className="outerWrapperTitle">
                <span className="outerWrapperIcon">

                </span>
                Scheduled Events
            </span>

            <div className={`frontPageQuilityParentBlockWrapper`} style={{width: '70%'}}>
                <div className="quilityParentBlockHeader">
                    <div className="quilityParentBlockTitle 111111">Scheduled Calls</div>
                </div>
                <div className="quilityParentBlockContent">
                    {scheduleCount > 0 && newData.map((item, index) => (
                        <div key={`scheduledCall${index}`}>
                            {item.tasks.length > 0 && <div className="dateGroupTitle">{formatDate(item.date)}</div>}
                            {item.tasks.map((call, index) => (
                                <div className={`quilityNestedBlockWrapper`} key={`itemTasks${index}`} style={{marginTop: '25px'}}>
                                    <div className="quilityCloseWindow oulineQuilityDestructiveButton" onClick={() => removeItem(call.callId)} >X</div>
                                    <div class="quilityNestedBlockHeader">
                                        <div class="quilityParentBlockTitle">{call.borrower_first} {call.borrower_last}</div>
                                    </div>
                                    <div className="infoWrapper">
                                        <div className="quilityDataLine">
                                            <span className="itemTitle" style={{display: 'inline-block',width: '140px'}}>Lead Name: </span>
                                            {call.borrower_first} {call.borrower_last}
                                        </div>
                                        <div className="quilityDataLine">
                                            <span className="itemTitle" style={{display: 'inline-block',width: '140px'}}>Time Scheduled: </span>
                                            {formatTimestamp(call.time)}
                                        </div>
                                        <div className="quilityDataLine">
                                            <span className="itemTitle" style={{display: 'inline-block',width: '140px'}}>Last Contacted: </span>
                                            {call.last_contacted !=null ? (
                                                    contactFormat(call.last_contacted)
                                            ) : (
                                                "Never contacted"
                                            )}
                                        </div>

                                        <span className="schedulefunctionButtons">
                                            <span className="wideBlockButton" onClick={() => openLead(call.lead_id)}>View Lead</span>
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                    {scheduleCount === 0 && (
                        <div className="title">You have no calls scheduled</div>
                    )}
                </div>
                <div className="blockFooter">
                    <div
                        className="buttonWrapper"
                        style={{ marginTop: " 5px", marginLeft: "10px" }}
                    >
                        <div className="dataButtonBlock">Scheduled Calls: {scheduleCount}</div>
                        <div className="actionButtonBlock" style={{width: '150px'}}>

                        </div>
                    </div>
                </div>

        </div>
    </div>

    );
}

export default ScheduledCalls;